import '../styles/ControlPanelStyle/DbUpdateStyle.css';
import FileUpload from "./FileUpload";

import ConnectionFinder from '../../api/ConnectionFinder';

const DBUpdateManager = () => {

    const fibreConnectUpdate = async (formData) => {
        await ConnectionFinder.post('/db-update/update/fibreconnect', formData, {
            headers: {
                "x-access-token": localStorage.getItem('token')
            },
            // Opzionale: puoi monitorare la progressione del caricamento
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                console.log(`Progresso: ${percentCompleted}%`);
            }
        });
    } 


    const unidataUpdate = async (formData) => {
        await ConnectionFinder.post('/db-update/update/unidata', formData, {
            headers: {
                "x-access-token": localStorage.getItem('token')
            },
            // Opzionale: puoi monitorare la progressione del caricamento
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                console.log(`Progresso: ${percentCompleted}%`);
            }
        });
    }

    return(
        <div className="ImportContainer">
            <h1 style={{textAlign: 'left', marginLeft: '20px', color: '#5F6A6A',marginBottom: '0px'}}>Gestisci tabelle del DB</h1>
            
            <h3 style={{textAlign: 'left', marginLeft: '20px', color: '#ff0f64',marginBottom: '0px'}}>FibreConnect</h3>
            <FileUpload 
                uploadHandler={fibreConnectUpdate} 
                text='Seleziona il file .xlsx contentente le tabelle da caricare.'
                placeholder='Scegli il file .xlsx (Excel)'
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            />
            <h3 style={{textAlign: 'left', marginLeft: '20px', color: '#ff0f64',marginBottom: '0px'}}>Unidata</h3>
            <FileUpload 
                uploadHandler={unidataUpdate}
                text='Seleziona il file .zip contenente le tabelle da caricare.'
                placeholder='Scegli il file .zip'
                accept='.zip,application/zip,application/x-zip-compressed'
            />

        </div>
    )
}

export default DBUpdateManager;